import React from 'react';

import BrandEdit from '@shared/brands/BrandEdit';

import brandService from '@services/admin/brandService';

const AdminBrandNew: React.FC = () => {
  return (
    <BrandEdit
      brandService={brandService}
      role="admin"
      showMerchantSelect={false}
    />
  );
};

export default AdminBrandNew;
